import { render, staticRenderFns } from "./cognition_team.vue?vue&type=template&id=46aa1c2a"
import script from "./cognition_team.vue?vue&type=script&lang=js"
export * from "./cognition_team.vue?vue&type=script&lang=js"
import style0 from "./cognition_team.vue?vue&type=style&index=0&id=46aa1c2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports